module.exports = __webpack_public_path__ + "static/media/killerwatt.37305b52.jpg";